<template>
  <div
    id="seasidetms_row_"
    class="seasidetms_row seasidetms_color_scheme_default seasidetms_row_top_default seasidetms_row_bot_default seasidetms_row_boxed"
  >
    <div class="seasidetms_row_outer_parent">
      <div class="seasidetms_row_outer">
        <div class="seasidetms_row_inner">
          <div class="seasidetms_row_margin seasidetms_11">
            <div id="seasidetms_column_" class="seasidetms_column one_first">
              <div class="seasidetms_column_inner">
                <div class="seasidetms_text">
                  <div v-html="$t('legal')"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Legal',
}
</script>

<style></style>
